import { combineReducers } from "redux"
import { Action, handleAction, handleActions } from "redux-actions"
import {
	SET_PAGE_TITLE,
	THROW_ERROR,
	NOTIFY,
	RECEIVE_CURRENT_LOCAL_AUTHORITY,
	RECEIVE_CURRENT_LOCAL_AUTHORITY_LOANS,
	RECEIVE_CURRENT_LOCAL_AUTHORITY_SERVICES,
	RECEIVE_CURRENT_USER,
	RECEIVE_LOCAL_AUTHORITIES,
	REQUEST_CURRENT_LOCAL_AUTHORITY,
	REQUEST_CURRENT_LOCAL_AUTHORITY_LOANS,
	REQUEST_CURRENT_LOCAL_AUTHORITY_SERVICES,
	REQUEST_CURRENT_USER,
	REQUEST_LOCAL_AUTHORITIES,
	UPDATE_CURRENT_LOCAL_AUTHORITY,
	UPDATE_LOANS_LOCALLY,
	UNNOTIFY,
	UPDATE_SERVICES_LOCALLY,
	REQUEST_LOCAL_AUTHORITIES_CHILDREN,
	RECEIVE_LOCAL_AUTHORITIES_CHILDREN,
	CLEAR_LOCAL_AUTHORITIES_CHILDREN,
	REQUEST_S3_FILES_LIST,
	RECIEVE_S3_FILES_LIST,
	SELECTED_PRIORITIES,
	REQUEST_ALL_SCENARIOS,
	RECIEVE_ALL_SCENARIOS,
	REQUEST_SELECTED_SCENARIOS,
	RECIEVE_SELECTED_SCENARIOS,
	REQUEST_SELECTED_SCENARIOS_DATA ,
    RECIEVE_SELECTED_SCENARIOS_DATA, 
	REQUEST_UPLOAD_FILE,
	RECIEVE_UPLOAD_FILE,
	LOADER_DATA_VALUE,
	RECIEVE_TABLE_DATA,
	SET_TOTAL_CALLS,
	INCREMENT_CALL,
	FINISH_CALL,
	SET_ALL_CALLS_FINISHED,
	RESET_ONGOIN_CALL

} from "./actions"
import * as actionCreators from "./action-creators"
import * as Model from "./model"
import { NotificationParams } from "./component/notification"

const titleReducer = handleAction<string, string>(
	SET_PAGE_TITLE,
	(state, action) => action.payload,
	'SFP Collectivités')

const errorReducer = handleAction(
	THROW_ERROR,
	(state, action) => action.payload,
	null
)

const localAuthorities = handleAction<Model.LocalAuthority[], Model.LocalAuthority[]>(
	RECEIVE_LOCAL_AUTHORITIES,
	(state, action) => action.payload,
	[]
)

const allScenarios = handleAction<Model.LocalAuthority[], Model.LocalAuthority[]>(
	RECIEVE_ALL_SCENARIOS,
	(state, action) => action.payload,
	[]
)

const fetchTableData = handleAction<Model.LocalAuthority[], Model.LocalAuthority[]>(
	RECIEVE_TABLE_DATA,
	(state, action) => action.payload,
	[]
)

const uplodeFileData = handleAction<Model.LocalAuthority[], Model.LocalAuthority[]>(
	RECIEVE_UPLOAD_FILE,
	(state, action) => action.payload,
	[]
)

const saveDataScenario  = handleAction<Model.LocalAuthority[], Model.LocalAuthority[]>(
RECIEVE_SELECTED_SCENARIOS_DATA,
(state, action) => action.payload,
[]
) 

const selectedScenarios = handleAction<Model.LocalAuthority[], Model.LocalAuthority[]>(
	RECIEVE_SELECTED_SCENARIOS,
	(state, action) => action.payload,
	[]
)

const localAuthoritiesChildren = handleActions<Model.LocalAuthority[], Model.LocalAuthority[]>(
	{
		[RECEIVE_LOCAL_AUTHORITIES_CHILDREN]: (state, action) => action.payload,
		[CLEAR_LOCAL_AUTHORITIES_CHILDREN]: (state, action) => [],
	},
	[]
)

const currentLocalAuthority = handleActions<Model.LocalAuthority>({
	[RECEIVE_CURRENT_LOCAL_AUTHORITY]: (state, action) => action.payload,
	[UPDATE_CURRENT_LOCAL_AUTHORITY]: (state, action) => action.payload
},
null)

const selectedPriorities = handleActions({
	[SELECTED_PRIORITIES]: (state, action) => action.payload,
},[])

const s3FilesList = handleActions({
	[RECIEVE_S3_FILES_LIST]: (state, action) => action.payload,
},[])

const loaderStoreData = handleActions({
	[LOADER_DATA_VALUE]: (state, action) => action.payload
},0)

const currentLocalAuthorityLoans = handleActions<Model.Loan[]>({
	[RECEIVE_CURRENT_LOCAL_AUTHORITY_LOANS]: (state, action) => action.payload,
	[UPDATE_LOANS_LOCALLY]: (state, action) => action.payload
},
[])

const currentLocalAuthorityServices = handleActions<Model.Service[]>({
	[RECEIVE_CURRENT_LOCAL_AUTHORITY_SERVICES]: (state, action) => action.payload,
	[UPDATE_SERVICES_LOCALLY]: (state, action) => action.payload,
	[RECIEVE_UPLOAD_FILE]: (state, action) => action.payload
},
[])

const currentUser = handleAction<Model.User, Model.User>(
	RECEIVE_CURRENT_USER,
	(state, action) => action.payload,
	null
)

const loadingUploadFile = handleActions<boolean>({
	[REQUEST_UPLOAD_FILE]: () => true,
	[RECIEVE_UPLOAD_FILE]: () => false
},
false)

const loadingCurrentLocalAuthority = handleActions<boolean>({
	[REQUEST_CURRENT_LOCAL_AUTHORITY]: () => true,
	[RECEIVE_CURRENT_LOCAL_AUTHORITY]: () => false
},
false)

const loadingSlectedScenario = handleActions<boolean>({
	[REQUEST_SELECTED_SCENARIOS]: () => true,
	[RECIEVE_SELECTED_SCENARIOS]: () => false
},
false)

const loadingS3FileList = handleActions<boolean>({
	[REQUEST_S3_FILES_LIST]: () => true,
	[RECIEVE_S3_FILES_LIST]: () => false
},false)

const loadingCurrentLocalAuthorityLoans = handleActions<boolean>({
	[REQUEST_CURRENT_LOCAL_AUTHORITY_LOANS]: () => true,
	[RECEIVE_CURRENT_LOCAL_AUTHORITY_LOANS]: () => false
},
false)

const loadingCurrentLocalAuthorityServices = handleActions<boolean>({
	[REQUEST_CURRENT_LOCAL_AUTHORITY_SERVICES]: () => true,
	[RECEIVE_CURRENT_LOCAL_AUTHORITY_SERVICES]: () => false
},
false)

const loadingtableData = handleActions<boolean>({
	[LOADER_DATA_VALUE]: () => true,
	[RECIEVE_TABLE_DATA]: () => false	
},
false)

const loadingCurrentUser = handleActions<boolean>({
	[REQUEST_CURRENT_USER]: () => true,
	[RECEIVE_CURRENT_USER]: () => false
},
false)

const loadingSavingScenarioData = handleActions<boolean>({
	[REQUEST_SELECTED_SCENARIOS_DATA]: () => true,
	[RECIEVE_SELECTED_SCENARIOS_DATA ]: () => false
},
false)

const loadingLocalAuthorities = handleActions<boolean>({
	[REQUEST_LOCAL_AUTHORITIES]: () => true,
	[RECEIVE_LOCAL_AUTHORITIES]: () => false
},
false)

const loadingScenarios = handleActions<boolean>({
	[REQUEST_ALL_SCENARIOS]: () => true,
	[RECIEVE_ALL_SCENARIOS]: () => false
},
false)

const loadingLocalAuthoritiesChildren = handleActions<boolean>({
	[REQUEST_LOCAL_AUTHORITIES_CHILDREN]: () => true,
	[RECEIVE_LOCAL_AUTHORITIES_CHILDREN]: () => false
},
false)


const notifications = handleActions<NotificationParams[], (NotificationParams|Symbol)>(
	{
		[NOTIFY]: (state, action: Action<NotificationParams>) => {
			const newState = state.slice()
			newState.push(action.payload)
			return newState
		},
		[UNNOTIFY]: (state, action: Action<Symbol>) => {
			const newState = state.slice()
			const index = newState.findIndex(n => n.symbol === action.payload)
			newState.splice(index, 1)
			return newState
		}
	},
	[]
)

const totalCalls = handleAction<number, number>(
    SET_TOTAL_CALLS,
    (state, action) => action.payload,
    0
);

const ongoingCalls = handleAction<number, number>(
    INCREMENT_CALL,
    (state) => state + 1,
    0
);

const ongoingCallsFinished = handleAction<number, number>(
    FINISH_CALL,
    (state) => Math.max(state - 1, 0),
    0
);

const allCallsFinished = handleAction<boolean, boolean>(
    SET_ALL_CALLS_FINISHED,
    (state, action) => action.payload,
    false // Valeur initiale
);

const resetOngoingCalls = handleAction<number, number>(
    RESET_ONGOIN_CALL,
    () => 0,
    0 // Valeur initiale
);


export default combineReducers<ReducerState>(
	{
		s3FilesList,
		loaderStoreData,
		currentLocalAuthority,
		currentLocalAuthorityLoans,
		currentLocalAuthorityServices,
		currentUser,
		error: errorReducer,
		loadingCurrentLocalAuthority,
		loadingS3FileList,
		loadingCurrentLocalAuthorityLoans,
		loadingCurrentLocalAuthorityServices,
		loadingCurrentUser,
		loadingLocalAuthorities,
		localAuthorities,
		loadingLocalAuthoritiesChildren,
		localAuthoritiesChildren,
		notifications,
		selectedPriorities,
		loadingScenarios,
		allScenarios,
		loadingSlectedScenario,
		selectedScenarios,
		loadingSavingScenarioData,
		saveDataScenario,
		title: titleReducer,
		uplodeFileData,
		loadingUploadFile,
		fetchTableData,
		loadingtableData,
		totalCalls,
		ongoingCalls,
		ongoingCallsFinished,
		allCallsFinished,
		resetOngoingCalls
	}
)

export interface MappedActionsProps {
	actions: BoundActionCreators
}

export interface ReducerState {
	currentLocalAuthority: Model.LocalAuthority
	currentLocalAuthorityLoans: Model.Loan[]
	currentLocalAuthorityServices: Model.Service[]
	currentUser: Model.User
	error: any
	loadingCurrentLocalAuthority: boolean
	loadingS3FileList: boolean
	loadingCurrentLocalAuthorityLoans: boolean
	loadingCurrentLocalAuthorityServices: boolean
	loadingCurrentUser: boolean
	loadingLocalAuthorities: boolean
	localAuthorities: Model.LocalAuthority[]
	loadingLocalAuthoritiesChildren: boolean
	localAuthoritiesChildren: Model.LocalAuthority[]
	notifications: NotificationParams[]
	title: string
	s3FilesList: any
	selectedPriorities?: number[]
	loadingScenarios:boolean
	loadingSlectedScenario:boolean
	selectedScenarios:any
	allScenarios:any
	loadingSavingScenarioData:boolean
	saveDataScenario:any
	uplodeFileData:any
	loadingUploadFile:boolean
	loaderDataValue: any
	loaderStoreData:any
	fetchTableData:any
	loadingtableData:boolean
	totalCalls: number
    ongoingCalls: number
	allCallsFinished: boolean
}

export type BoundActionCreators = typeof actionCreators



// WEBPACK FOOTER //
// ./src/reducer.ts